import consentthing from "@/components/consentDeclaration/consentDeclarationCard.vue"
export default [
  {
    path: "/",
    name: "Home",
    meta: { navbarTitle: "roody" },
    //fullWidth: true, backgroundColor: "#212121"
    component: () => import(/* webpackChunkName: "HomeNew.vue" */ "@/views/HomeNew.vue"),
    children: [
      {
        path: "panel",
        name: "employeePanel",
        meta: { hideBottomNavigation: true },
        component: () => import("@/views/employee/employeePanel.vue"),
        children: [
          {
            path: "membercard",
            name: "MembercardView",
            meta: { hideBottomNavigation: true },
            component: () => import("@/views/employee/MembercardView.vue"),
          },
        ],
      },
      {
        path: "select-employee",
        name: "selectEmployee",
        meta: {
          hideBottomNavigation: true, // Versteckt die untere Navigation
          // Hier kannst du weitere Meta-Tags hinzufügen
        },
        // Lädt die Dialog-Komponente als Seiteninhalt
        component: () => import("@/components/employee/employeeSelectionDialog.vue"),
      },
    ],
  },
  {
    path: "*",
    name: "catchAll",
    component: () => import(/* webpackChunkName: "HomeNew.vue" */ "@/views/HomeNew.vue"),
  },
  { path: "/consent", name: "consent", component: consentthing },
  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { hideAppBar: true },
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
  {
    path: "/register",
    name: "Registrieren",
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
]
